import {initializeClickableRowsContacts} from './functions';
import {
    addTypeableFieldParts,
    coarsePointer,
    findOptionByLabel,
    initTypeableFormSubmit,
    nameKey,
    narrowScreen,
    refreshTypeableField,
    shorten,
    typeableScore,
} from './combobox';

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector(".orders-page")) {
        initializeClickableRowsContacts();
    }

    function checkShippingCompany(element) {
        const customInput = document.getElementById('custom_shipping_company');
        if (element.val() === 'custom') {
            customInput.style.display = 'block';
        } else {
            customInput.style.display = 'none';
            customInput.value = ''; // Clear the input value when hidden
        }
    }

    function checkShippingType(element) {
        const shippingType = element.value.toLowerCase();
        const shippingAddress = $('.shipping-address');

        if (shippingType.startsWith('pickup')) {
            shippingAddress.hide();
            shippingAddress.find('input, select, textarea').each(function () {
                $(this).removeAttr('required');
            });
        } else {
            shippingAddress.show();
            shippingAddress.find('input, select, textarea').each(function () {
                if (!$(this).hasClass('not-required')) {
                    $(this).attr('required', 'required');
                }
            });
        }
    }

    function checkOrderType(orderType) {
        if (orderType === 'order' || orderType === 'pre_order') {
            $('#shipping_price, #fee_percent').closest('.input-container').parent().show();
        } else {
            $('#shipping_price, #fee_percent').closest('.input-container').parent().hide();
        }
    }

    function copyAddress() {
        const shippingType = $('#shipping_type').val().toLowerCase();
        if (!shippingType.startsWith('pickup')) {
            $('#shipping_to_company').val($('#billing_to_company').val());
            $('#shipping_address').val($('#billing_address').val());
            $('#shipping_country').val($('#billing_country').val());
            $('#shipping_state').val($('#billing_state').val());
            $('#shipping_city').val($('#billing_city').val());
            $('#shipping_zip').val($('#billing_zip').val());
            $('#shipping_phone').val($('#billing_phone').val());
            $('#shipping_email').val($('#billing_email').val());
        }
    }

    // Display-only money format (line totals and the summary): 1234.5 -> "1,234.50".
    // These fields are never submitted; quantity and price inputs stay plain numbers.
    function formatMoney(amount) {
        return (Number(amount) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function calculateTotal() {
        let subtotal = 0;

        $('#productItemsContainer .product_item').each(function () {
            const quantity = parseFloat($(this).find('#quantity').val()) || 0;
            const price = parseFloat($(this).find('#price').val()) || 0;
            const total = quantity * price;

            $(this).find('#total').val(formatMoney(total));
            subtotal += total;
        });

        const shippingPrice = parseFloat($('#shipping_price').val()) || 0;
        const feePercent = parseFloat($('#fee_percent').val()) || 0;
        const feeAmount = ((subtotal + shippingPrice) * feePercent) / 100;
        const totalAmount = subtotal + shippingPrice + feeAmount;

        $('#subtotal').text(formatMoney(subtotal));
        $('#totalAmount').text(formatMoney(totalAmount));
    }

    // ---- Product lines: a typeable product field ----------------------------------------
    // Each line's product is a TomSelect on an unnamed <select class="product_select"> that
    // behaves like a text field (combobox.js: the fx_typeable plugin and shared helpers): type
    // for suggestions (name + catalog price), pick one, or confirm a name that is not in the
    // catalog with the 'Add "<name>" as new product' row.
    // An empty field also lists the whole catalog when it is focused or tapped (a hybrid).
    // Two hidden inputs per line carry what is submitted: products[i][product_id] (a catalog
    // product) or products[i][new_product] (a confirmed new name the server adds to the catalog
    // on save, reusing a product of the same name ignoring case;
    // OrderController::resolveNewProducts). Leaving the field never picks or creates anything:
    // only Enter, Tab or a click/tap on a suggestion or on the Add row does.
    const NEW_PRODUCT_PREFIX = 'new:';
    const PRODUCT_NAME_MAX = 255; // OrderRequest products.*.new_product max
    const PRODUCT_PLACEHOLDER = 'Type to search or add a product';
    const PRODUCT_PLACEHOLDER_SHORT = 'Search or add a product';
    const PRODUCT_REQUIRED_MESSAGE = 'Choose a product or type a new product name.';
    let productCatalog = null;

    // The catalog printed by form-products.blade.php (#orderProductCatalog), parsed once
    function getProductCatalog() {
        if (productCatalog !== null) {
            return productCatalog;
        }

        productCatalog = [];
        const source = document.getElementById('orderProductCatalog');
        if (source) {
            try {
                const parsed = JSON.parse(source.textContent || '[]');
                if (Array.isArray(parsed)) {
                    productCatalog = parsed.map(product => ({
                        value: String(product.value),
                        text: String(product.text ?? ''),
                        price: Number(product.price) || 0,
                        desc: Boolean(product.desc),
                        isNew: false,
                    }));
                }
            } catch (error) {
                productCatalog = [];
            }
        }

        return productCatalog;
    }

    // Catalog prices: the price input steps by .001, the suggestions show 2-3 decimals
    function roundPrice(price) {
        return Math.round((Number(price) || 0) * 1000) / 1000;
    }

    function formatPrice(price) {
        return roundPrice(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
    }

    // The price input value: "354.90", "12.00", "12.345" (as the suggestions and totals read)
    function formatPriceInput(price) {
        const fixed = roundPrice(price).toFixed(3);
        return fixed.endsWith('0') ? fixed.slice(0, -1) : fixed;
    }

    function initProductSelect(selectElement) {
        if (!selectElement) {
            return null;
        }
        if (selectElement.tomselect) {
            return selectElement.tomselect;
        }

        // Every field gets its own copy: TomSelect caches rendered markup on its option objects
        const options = getProductCatalog().map(product => Object.assign({}, product));
        const items = [];
        const selected = selectElement.selectedOptions[0];

        if (selected && selected.value) {
            // A product deleted from the catalog since (edit) or a typed new product
            // (after a failed save) is not in the catalog: add it for this line only
            if (!options.some(option => option.value === selected.value)) {
                options.push({
                    value: selected.value,
                    text: selected.textContent.trim(),
                    price: Number(selected.dataset.price) || 0,
                    desc: selected.dataset.desc === '1',
                    isNew: selected.dataset.new === '1',
                });
            }
            items.push(selected.value);
        }

        const tomSelect = new TomSelect(selectElement, {
            plugins: [
                { name: 'fx_typeable', options: { heading: 'All products · type to filter' } },
                'restore_on_backspace',
            ],
            options,
            items,
            placeholder: narrowScreen.matches ? PRODUCT_PLACEHOLDER_SHORT : PRODUCT_PLACEHOLDER,
            hidePlaceholder: true,
            openOnFocus: false,       // fx_typeable: only an empty field lists the catalog on focus
            // Refresh on every keystroke (the catalog is local): with TomSelect's 300ms throttle
            // a quick Enter / Tab would take the suggestion highlighted for the previous text
            refreshThrottle: 0,
            maxOptions: 500,
            searchField: ['text'],
            // Match anywhere in the name, ignoring case and accents (combobox.js typeableScore)
            diacritics: false,
            score: typeableScore,
            sortField: [{ field: '$score', direction: 'desc' }, { field: '$order' }],
            controlInput: '<input type="text" autocomplete="off" autocorrect="off" spellcheck="false" enterkeyhint="done" size="1" aria-label="Product">',
            create(input) {
                const name = input.trim();
                return { value: NEW_PRODUCT_PREFIX + name, text: name, price: 0, desc: false, isNew: true };
            },
            createFilter(input) {
                const name = input.trim();
                return name.length > 0 && name.length <= PRODUCT_NAME_MAX && !findOptionByLabel(this, name);
            },
            render: {
                option(data, escape) {
                    const meta = data.isNew
                        ? '<span class="fx-combobox__badge" title="Added to the catalog when the order is saved">New</span>'
                        : `<span class="fx-combobox__meta">$${escape(formatPrice(data.price))}</span>`;
                    return `<div class="fx-combobox__option"><span class="fx-combobox__label">${escape(data.text)}</span>${meta}</div>`;
                },
                item(data, escape) {
                    const badge = data.isNew
                        ? '<span class="fx-combobox__badge" title="Added to the catalog when the order is saved">New</span>'
                        : '';
                    return `<div><span class="fx-combobox__label">${escape(data.text)}</span>${badge}</div>`;
                },
                option_create(data, escape) {
                    return `<div class="create fx-combobox__create" role="option" id="${escape(this.inputId)}-ts-create">`
                        + '<i class="fa-solid fa-plus" aria-hidden="true"></i>'
                        + `<span>Add "<strong>${escape(data.input.trim())}</strong>" as new product`
                        + '<small>Saved to the product catalog with this order</small></span></div>';
                },
                no_results(data, escape) {
                    let message = 'No matching products';
                    if ((data.input || '').trim().length > PRODUCT_NAME_MAX) {
                        message = `A product name can be at most ${PRODUCT_NAME_MAX} characters`;
                    } else if (!getProductCatalog().length) {
                        message = 'No products in the catalog yet';
                    }
                    return `<div class="no-results">${escape(message)}</div>`;
                },
            },
            onChange(value) {
                productChanged(this, value);
            },
        });

        // The line's current product: choosing the same one again keeps quantity and price
        tomSelect.fxProductValue = tomSelect.getValue();

        // Accessibility: required, and the field's value / help / error read with it
        const control = tomSelect.control_input;
        if (selectElement.required) {
            control.setAttribute('aria-required', 'true');
        }
        const container = selectElement.closest('.input-container');
        if (container) {
            // A product error from the server (failed save): shown until the line is complete
            addTypeableFieldParts(tomSelect, container.querySelector(':scope > .error-message'));
        }

        tomSelect.on('type', () => refreshProductField(tomSelect));
        tomSelect.on('blur', () => refreshProductField(tomSelect));
        tomSelect.on('focus', () => refreshProductField(tomSelect));
        tomSelect.on('fx_pending', () => refreshProductField(tomSelect));
        tomSelect.on('fx_text', () => refreshProductField(tomSelect));
        selectElement.addEventListener('invalid', () => {
            tomSelect.wrapper.classList.add('fx-combobox--invalid');
            refreshProductField(tomSelect, true);
        });

        // A new product is added to the catalog at the line's price: the help line says which
        const productItem = selectElement.closest('.product_item');
        const priceInput = productItem ? productItem.querySelector('.product_price') : null;
        if (priceInput) {
            priceInput.addEventListener('input', () => refreshProductField(tomSelect));
        }

        syncProductFields(tomSelect);
        productDescriptionVisibility(selectElement);
        refreshProductField(tomSelect);

        return tomSelect;
    }

    // What the line's product field still needs ('' when it holds a product)
    function productProblem(tomSelect) {
        if (tomSelect.getValue()) {
            return '';
        }
        const text = tomSelect.inputValue();
        if (text.length > PRODUCT_NAME_MAX) {
            return `A product name can be at most ${PRODUCT_NAME_MAX} characters.`;
        }
        if (text !== '') {
            return `Pick a suggestion or choose Add "${shorten(text)}" as new product.`;
        }
        return PRODUCT_REQUIRED_MESSAGE;
    }

    // Validity (the save checks it), the inline error and help line, and the ARIA state of a
    // line's product field (combobox.js refreshTypeableField). `fromSaveAttempt`: the save was
    // blocked by this field.
    function refreshProductField(tomSelect, fromSaveAttempt = false) {
        const select = tomSelect.input;
        const value = tomSelect.getValue();
        const option = value ? tomSelect.options[value] : null;

        refreshTypeableField(tomSelect, {
            problem: productProblem(tomSelect),
            fromSaveAttempt,
            describe(invalid) {
                // Help line: what a new product does on save, or text that is not chosen yet
                let message = '';
                let tone = 'note';
                if (!invalid && option && option.isNew) {
                    const priceInput = select.closest('.product_item')?.querySelector('.product_price');
                    const price = priceInput ? parseFloat(priceInput.value) || 0 : 0;
                    if (price > 0) {
                        message = `New product: added to the catalog at $${formatPrice(price)} when you save.`;
                    } else {
                        message = 'New product: enter its price. It is added to the catalog at that price when you save.';
                        tone = 'warn';
                    }
                } else if (!invalid && !value && tomSelect.fxPending && tomSelect.inputValue() !== '') {
                    message = tomSelect.inputValue().length > PRODUCT_NAME_MAX
                        ? `A product name can be at most ${PRODUCT_NAME_MAX} characters.`
                        : `Not chosen yet: pick a suggestion or add "${shorten(tomSelect.inputValue())}" as a new product.`;
                    tone = 'warn';
                }
                return {
                    help: message,
                    tone,
                    value: option ? (option.isNew ? `New product: ${option.text}` : `Product: ${option.text}`) : '',
                };
            },
        });
    }

    // Copy the field's value into the line's hidden inputs (what the form submits)
    function syncProductFields(tomSelect) {
        const productItem = tomSelect.input.closest('.product_item');
        if (!productItem) {
            return;
        }

        const value = tomSelect.getValue();
        const option = value ? tomSelect.options[value] : null;
        productItem.querySelector('.product_id_input').value = option && !option.isNew ? option.value : '';
        productItem.querySelector('.product_new_input').value = option && option.isNew ? option.text : '';
    }

    // A new product typed on one line is offered (with its New badge) on the other lines too,
    // as long as some line uses it
    function shareNewProducts() {
        const fields = [...document.querySelectorAll('#productItemsContainer select.product_select')]
            .map(select => select.tomselect)
            .filter(Boolean);
        const inUse = new Map();
        fields.forEach(field => {
            [field.getValue(), field.fxLastValue].forEach(value => {
                const option = value ? field.options[value] : null;
                if (option && option.isNew && !inUse.has(nameKey(option.text))) {
                    inUse.set(nameKey(option.text), option);
                }
            });
        });

        fields.forEach(field => {
            inUse.forEach(option => {
                if (!findOptionByLabel(field, option.text)) {
                    field.addOption({ value: option.value, text: option.text, price: 0, desc: false, isNew: true });
                }
            });
            Object.values(field.options).forEach(option => {
                if (option.isNew && option.value !== field.getValue() && option.value !== field.fxLastValue
                    && !inUse.has(nameKey(option.text))) {
                    field.removeOption(option.value);
                }
            });
        });
    }

    function productChanged(tomSelect, value) {
        const productItem = $(tomSelect.input).closest('.product_item');
        const option = value ? tomSelect.options[value] : null;
        const via = tomSelect.fxSelectVia;

        syncProductFields(tomSelect);

        if (option && value !== tomSelect.fxProductValue) {
            tomSelect.fxProductValue = value;

            // A catalog product brings its price (still editable) and quantity 1;
            // a new product keeps whatever the line already holds
            if (!option.isNew) {
                productItem.find('#quantity').val(1);
                productItem.find('#price').val(formatPriceInput(option.price));
            }
            // A description belongs to the product it was written for: a product without one
            // must not save (and email) the previous product's text
            if (option.isNew || !option.desc) {
                productItem.find('#description').val('');
            }
        }

        productDescriptionVisibility(tomSelect.input);
        calculateTotal();
        shareNewProducts();
        refreshProductField(tomSelect);

        // After a pick: a new product goes on to its price (unless Tab is moving focus anyway);
        // on a touch screen a catalog product closes the keyboard. As soon as TomSelect has
        // finished handling the key or click (a microtask: before the next keystroke arrives)
        if (option && via && via !== 'tab') {
            queueMicrotask(() => {
                if (option.isNew) {
                    const price = productItem.find('#price')[0];
                    if (price) {
                        price.focus();
                        price.select();
                    }
                } else if (via === 'pointer' && coarsePointer.matches && tomSelect.isFocused) {
                    tomSelect.blur();
                }
            });
        }
    }

    function productDescriptionVisibility(productElement) {
        const tomSelect = productElement.tomselect;
        const value = tomSelect ? tomSelect.getValue() : '';
        const option = value ? tomSelect.options[value] : null;
        const descriptionField = $(productElement).closest('.product_item').find('#description').closest('.col');

        descriptionField.toggleClass('d-none', !(option && option.desc && !option.isNew));
    }

    if (document.querySelector(".order-create-page") || document.querySelector(".order-edit-page")) {
        let orderTypeSelect = $('#order_type');
        let shippingCompanySelect = $('#shipping_company');

        checkOrderType(orderTypeSelect.val());
        checkShippingType(document.getElementById('shipping_type'));
        checkShippingCompany(shippingCompanySelect);
        calculateTotal();

        orderTypeSelect.on('change', function () {
            checkOrderType($(this).val());
        });
        document.getElementById('shipping_type').addEventListener('change', function () {
            checkShippingType(this);
        });
        shippingCompanySelect.on('change', function () {
            checkShippingCompany(shippingCompanySelect);
        });
        $(document).on('input change', '#productItemsContainer .product_item input, #shipping_price, #fee_percent', function () {
            calculateTotal();
        });
        // Choosing a product: initProductSelect -> productChanged (TomSelect onChange)
        const orderForm = document.querySelector('#createOrderForm, #orderForm');
        if (orderForm) {
            // Saving: a product field that blocks the save gets an inline message and the focus
            // (not the browser bubble pointing at the hidden <select>); a valid save is sent once
            initTypeableFormSubmit(orderForm, 'select.product_select');
        }
        const productItemsContainer = document.getElementById('productItemsContainer');
        const addProductItemButton = document.getElementById('addProductItem');
        // A pristine copy of the product field (attributes only), taken before TomSelect or the
        // locked-order code touch it: every added line gets a fresh field from it
        const firstProductSelect = productItemsContainer.querySelector('select.product_select');
        const productSelectTemplate = firstProductSelect ? firstProductSelect.cloneNode(false) : null;

        // Add new product item
        addProductItemButton.addEventListener('click', () => {
            const productItemElement = $('#productItemsContainer .product_item');
            const productItem = productItemElement.first();

            if (!productItem.length || !productSelectTemplate) {
                return;
            }

            const newProductItem = productItem.clone();

            newProductItem.find('#quantity').val(1);
            newProductItem.find('#price').val(0);
            newProductItem.find('#total').val(formatMoney(0));
            // A new line starts blank: no copied description, and the description field
            // stays hidden until a product that uses one is picked.
            newProductItem.find('#description').val('');
            newProductItem.find('#description').closest('.col').addClass('d-none');
            newProductItem.find('.error-message').remove();

            // On edit the row keys are order item ids (the server updates the item with that id),
            // so a new row must use a key above every key in the form, not the row count.
            let newIndex = productItemElement.length;
            productItemElement.find('[name^="products["]').each(function () {
                const match = $(this).attr('name').match(/^products\[(\d+)\]/);
                if (match) {
                    newIndex = Math.max(newIndex, parseInt(match[1], 10) + 1);
                }
            });
            newProductItem.find('input, select, textarea').each(function () {
                const name = $(this).attr('name');
                if (name) {
                    const updatedName = name.replace(/\[\d+\]/, `[${newIndex}]`);
                    $(this).attr('name', updatedName);
                }
            });

            // A fresh, empty product field: the copied TomSelect markup, select, help and
            // messages go; its label points at the new field
            newProductItem.find('.product_id_input, .product_new_input').val('');
            newProductItem.find('.ts-wrapper, .fx-combobox-value, .fx-combobox-help').remove();
            const productElement = productSelectTemplate.cloneNode(false);
            productElement.id = `product_select_${newIndex}`;
            productElement.add(new Option(PRODUCT_PLACEHOLDER, ''));
            newProductItem.find('select.product_select').replaceWith(productElement);
            newProductItem.find('.product_item__product label.form-label')
                .attr('for', productElement.id)
                .removeAttr('id');

            $('#productItemsContainer').append(newProductItem);
            const tomSelect = initProductSelect(productElement);
            shareNewProducts();
            calculateTotal();
            // Ready to type: the new line comes into view with the caret in its product field
            newProductItem[0].scrollIntoView({ block: 'nearest' });
            if (tomSelect) {
                tomSelect.focus();
            }
        });

        // Remove product item
        productItemsContainer.addEventListener('click', (event) => {
            if (event.target.classList.contains('remove-product-item')) {
                const productItem = event.target.closest('.product_item');
                if (productItemsContainer.children.length > 1) {
                    // TomSelect listens on document/window: release them with the line
                    const productSelect = productItem.querySelector('select.product_select');
                    if (productSelect && productSelect.tomselect) {
                        productSelect.tomselect.destroy();
                    }
                    productItem.remove();
                    shareNewProducts();
                    calculateTotal();
                } else {
                    alert('At least one product item is required.');
                }
            }
        });
    }

    if (document.querySelector(".order-create-page") || document.querySelector(".order-edit-page")) {
        $('#copyBillingToShipping').on('click', function () {
            copyAddress();
        });
    }

    if (document.querySelector(".order-create-page")) {
        $(document).ready(function () {
            // Every row (more than one after a failed submit) gets its product picker
            document.querySelectorAll('#productItemsContainer select.product_select').forEach(function (productElement) {
                initProductSelect(productElement);
            });
            shareNewProducts();
        });
    }

    if (document.querySelector(".order-edit-page")) {
        const form = document.getElementById('orderForm');
        const initialDisabledState = form.getAttribute('data-disabled') === 'true';

        if (initialDisabledState) {
            // Disable all form elements
            const formElements = form.elements;
            for (let i = 0; i < formElements.length; i++) {
                const element = formElements[i];
                if (!element.classList.contains('no-disabled')) {
                    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
                        element.readOnly = true;
                    } else {
                        element.disabled = true;
                    }
                }
            }
        }

        document.querySelectorAll('#productItemsContainer select.product_select').forEach(function (productElement) {
            initProductSelect(productElement);
        });
        shareNewProducts();
    }
});
